import React from "react";

const ServerError: React.FC = () => {
  return <div>server error</div>;
};

export default ServerError;
